import img1 from "../assets/images/gallery/mnb-1.jpg";
import img2 from "../assets/images/gallery/mnb-2.jpeg";
import img3 from "../assets/images/gallery/mnb-3.jpeg";
import img4 from "../assets/images/gallery/mnb-4.jpg";
import img5 from "../assets/images/gallery/mnb-5.jpg";
import img6 from "../assets/images/gallery/mnb-6.jpg";
import img7 from "../assets/images/gallery/mnb-7.jpg";
import img8 from "../assets/images/gallery/mnb-8.jpg";
import img9 from "../assets/images/gallery/mnb-9.jpeg";
import img10 from "../assets/images/gallery/mnb-10.jpeg";
import img11 from "../assets/images/gallery/mnb-11.jpeg";
import img12 from "../assets/images/gallery/mnb-12.jpg";
import FadeInSection from "./FadeInSection";

function PhotoGallery() {
	const galleryImages = [
		{ src: img1, alt: "Stylist working on client 1" },
		{ src: img2, alt: "Stylist working on client 2" },
		{ src: img3, alt: "Stylist working on client 3" },
		{ src: img4, alt: "Stylist working on client 4" },
		{ src: img5, alt: "Stylists working on clients back to back" },
		{ src: img6, alt: "Team smiling together" },
		{ src: img7, alt: "Estheticien client relaxing with mist 1" },
		{ src: img8, alt: "Estheticien working on client 1" },
		{ src: img9, alt: "Estheticien client relaxing with mist 2" },
		{ src: img10, alt: "Estheticien working on client 2" },
		{ src: img11, alt: "Estheticien working on client 3" },
		{ src: img12, alt: "Stylist working on client 5" },
	];

	return (
		<div className="gallery-container">
			<div className="container">
				<FadeInSection animationType="fade-left">
					<h2>Photo Gallery</h2>
					<hr />
					<div className="gallery-grid mt-5">
						{galleryImages.map((image, index) => (
							<img key={index} src={image.src} alt={image.alt} className="gallery-image" />
						))}
					</div>
				</FadeInSection>
			</div>
		</div>
	);
}

export default PhotoGallery;
